export const APP_NAME = 'Manager View';
export const APP_SCOPE = 'closemydeals.app.access';

// Fallback Pendo account id used when the authenticated user has no
// accountId; must match the value passed to `window.pendo.initialize`.
export const DEFAULT_PENDO_ACCOUNT_ID = 'dc_manager_view';
export const CLIENT_ID = '0oamgt9ifuZnQZhuL357';
export const NON_PROD_CLIENT_ID = '0oamgtds2huTe13du357';

export const OKTA_CONFIG_ID_PROD = 'cmd_prod_bridge_signin_spa_makemydeal';
export const OKTA_CONFIG_ID_NON_PROD = 'cmd_qa_bridge_signin_spa_makemydeal';
